import { combineReducers } from 'redux';
import marketStimateReducer from './MarketStimateReducer.js';

const marketRootReducer = combineReducers( {
  marketStimate: marketStimateReducer,
  // Agrega aquí más reducers específicos del módulo si los tienes
} );

export default marketRootReducer;
